export default "__VITE_ASSET__29f862c3__"